const ItemSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_CUSTOMER",
                "tableName": "",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "customerName",
                "tableName": "",
                "label": "Customer Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "itemCode",
                "tableName": "",
                "label": "item Code",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "itemDescription1",
                "tableName": "",
                "label": "Description1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }
];
export default ItemSearchFormLayout;